import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_2 = { class: "customer-card-content d-flex align-center" }
const _hoisted_3 = { class: "text-h5 text-white" }
const _hoisted_4 = { class: "customer-info min-width-0 flex-grow-1" }
const _hoisted_5 = { class: "font-weight-bold text-truncate mb-0" }
const _hoisted_6 = { class: "text-body-2 text-medium-emphasis text-truncate my-2" }
const _hoisted_7 = { class: "d-flex align-center flex-wrap gap-1 mt-1" }
const _hoisted_8 = { class: "text-h5 text-medium-emphasis" }
const _hoisted_9 = { class: "text-body-1 text-disabled" }

import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import AppCard from '@/shared/components/ui/AppCard.vue';
import { fetchCustomers } from "@/modules/vendor/services/vendors.api";

interface Customer {
  id: number;
  name: string;
  address: string;
  appointments: number;
  subscriptions: number;
  inquiries: number;
  color: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomersPage',
  setup(__props) {

const router = useRouter();

const searchQuery = ref('');
const isLoading = ref(false);
const errorMessage = ref("");

const customers = ref<Customer[]>([]);


const filteredCustomers = computed(() => {
  return customers.value.filter(c => {
    return c.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
           c.address.toLowerCase().includes(searchQuery.value.toLowerCase());
  });
});

function asArray(response: any): any[] {
  const data = response?.data ?? response;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.customers)) return data.customers;
  return [];
}

function formatAddress(item: any) {
  if (typeof item?.address === "string") return item.address;
  const address = item?.address || {};
  return [address.line_1, address.line_2, address.city, address.state, address.zip]
    .filter(Boolean)
    .join(", ");
}

function normalizeCustomer(item: any, index: number): Customer {
  const name = item?.name || item?.full_name || [item?.first_name, item?.last_name].filter(Boolean).join(" ");
  return {
    id: Number(item?.id ?? index),
    name: String(name || "Customer"),
    address: formatAddress(item),
    appointments: Number(item?.appointments ?? item?.appointment_count ?? 0),
    subscriptions: Number(item?.subscriptions ?? item?.subscription_count ?? 0),
    inquiries: Number(item?.inquiries ?? item?.inquiry_count ?? 0),
    color: "blue-darken-2",
  };
}

async function loadCustomers() {
  isLoading.value = true;
  errorMessage.value = "";
  try {
    const response = await fetchCustomers();
    customers.value = asArray(response).map(normalizeCustomer);
  } catch (error: any) {
    errorMessage.value = error?.response?.data?.message || error?.message || "Failed to load customers.";
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  loadCustomers();
});

const getInitials = (name: string) => {
  return name.split(' ').map(n => n[0]).join('').toUpperCase();
};

const goToDetail = (id: number) => {
  router.push({ name: 'vendor.customers.detail', params: { id } }).catch(() => {});
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "customers-page"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "align-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                "prepend-inner-icon": "mdi-magnify",
                placeholder: "Search customers...",
                variant: "outlined",
                "hide-details": "",
                density: "comfortable",
                class: "search-field"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]))
        : (filteredCustomers.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCustomers.value, (customer) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: customer.id,
                    cols: "12",
                    sm: "6",
                    lg: "4",
                    class: "pb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppCard, {
                        class: "customer-card clickable-card h-100",
                        onClick: ($event: any) => (goToDetail(customer.id))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_avatar, {
                              size: "56",
                              color: customer.color,
                              class: "elevation-1 mr-4"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(getInitials(customer.name)), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"]),
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("h4", _hoisted_5, _toDisplayString(customer.name), 1),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createTextVNode("mdi-map-marker-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(customer.address), 1)
                              ]),
                              _createElementVNode("div", _hoisted_7, [
                                (customer.appointments > 0)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "small",
                                      color: "",
                                      variant: "tonal",
                                      label: "",
                                      class: "mr-2 mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(customer.appointments) + " Appt. ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (customer.subscriptions > 0)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 1,
                                      size: "small",
                                      color: "",
                                      variant: "tonal",
                                      label: "",
                                      class: "mr-2 mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(customer.subscriptions) + " Subsc. ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (customer.inquiries > 0)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 2,
                                      size: "small",
                                      color: "",
                                      variant: "tonal",
                                      label: "",
                                      class: "mr-2 mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(customer.inquiries) + " Inq. ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createVNode(_component_v_icon, { color: "grey-lighten-1" }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-chevron-right", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 2,
              class: "mt-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "64",
                      color: "grey-lighten-1",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-account-search-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("h3", _hoisted_8, _toDisplayString(errorMessage.value ? "Unable to load customers" : "No customers found"), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(errorMessage.value || "Try adjusting your search"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
    ]),
    _: 1
  }))
}
}

})